<template>
    <div class="employee-skills">
        <div class="row">
            <div class="col-lg-4">
                <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="employees.employeeSkills" />
                        Hvilke svende er gode til hvilke opgaver?
                    </div>
                    <div class="placeholder fit-content">

                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="selectEmployee"
                            :row-style-class="selectedRowClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div>
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="info" v-if="!selectedRow">
                    Vælg en medarbejder for at se hvor god denne er til forskellige opgavetyper
                </div>
                <employee-skills-single :data="selectedRow" v-else />
            </div>
        </div>

    </div>
</template>

<script>
import * as employeeService from '@/services/employeeService'

export default {
    data () {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [
                { label: 'Initialer', field: 'initials', type: 'string' },
                { label: 'Medarbejder', field: 'full_name', type: 'string' }
                /* { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' } */
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
                /* initialSortBy: {
                    field: 'invoices_total',
                    type: 'desc'
                } */
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            employeeService.findAll({}, (response) => {
                let employees = []
                response.data.forEach((employee) => {
                    if (employee.working_field) {
                        employees.push(employee)
                    }
                })
                this.rows = employees
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectEmployee (employee) {
            this.selectedRow = employee.row
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected'
            }
        }
    },
    components: {
        'employee-skills-single': require('./employeeSkillsSingle.vue')
    }
}
</script>



// WEBPACK FOOTER //
// employeeSkills.vue?f0755950